/* eslint-disable */
import {
  Modal,
  View,
  Text,
  Alert,
  Platform,
  Pressable,
  StyleSheet,
  TouchableOpacity,
  Touchable,
} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import EnglishFlag from '../assets/English.svg';
import DutchFlag from '../assets/Dutch.svg';
import {useTranslation} from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import PrimaryButton from './PrimaryButton';
import {colors, fonts, radii, shadows, spacing, typography} from '../config/theme';

const LanguageOption = ({label, Flag, selected, onPress}) => (
  <Pressable
    onPress={onPress}
    accessibilityRole="radio"
    accessibilityState={{selected}}
    style={({pressed}) => [
      styles.languageItem,
      selected && styles.languageItemSelected,
      pressed && styles.languageItemPressed,
    ]}>
    <Flag width={32} height={32} />
    <Text style={styles.languageText}>{label}</Text>
    <View style={[styles.radio, selected && styles.radioSelected]}>
      {selected && <View style={styles.radioDot} />}
    </View>
  </Pressable>
);

export const LanguageModal = ({modalVisible, setModalVisible}) => {
  const {i18n} = useTranslation();
  const insets = useSafeAreaInsets();
  // Mirrors ProfileList: anything other than 'en' shows as Dutch.
  const isEnglish = i18n.language == 'en';

  const handleLanguageChange = async language => {
    i18n.changeLanguage(language);
    await AsyncStorage.setItem('languagePreference', language);
    setModalVisible(false);
  };
  return (
    <Modal
      animationType="slide"
      visible={modalVisible}
      transparent={true}
      statusBarTranslucent
      onRequestClose={() => setModalVisible(false)}>
      <View style={styles.backdrop} onPress={() => setModalVisible(false)}>
        <View
          style={[
            styles.sheet,
            {
              paddingBottom:
                spacing.lg + (Platform.OS === 'ios' ? insets.bottom : 0),
            },
          ]}>
          <View style={styles.handle} />
          <Text style={styles.title}>Select Preferred Language</Text>
          <View style={styles.languageContainer}>
            <LanguageOption
              label="English"
              Flag={EnglishFlag}
              selected={isEnglish}
              onPress={() => {
                handleLanguageChange('en');
              }}
            />
            <LanguageOption
              label="Dutch"
              Flag={DutchFlag}
              selected={!isEnglish}
              onPress={() => {
                handleLanguageChange('dt');
              }}
            />
          </View>
          <PrimaryButton
            title="Cancel"
            variant="secondary"
            onPress={() => setModalVisible(false)}
          />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: colors.overlay,
  },
  sheet: {
    width: '100%',
    backgroundColor: colors.surface,
    borderTopLeftRadius: radii.sheet,
    borderTopRightRadius: radii.sheet,
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.md,
    ...shadows.level2,
  },
  handle: {
    alignSelf: 'center',
    width: 40,
    height: 4,
    borderRadius: radii.pill,
    backgroundColor: colors.border,
    marginBottom: spacing.lg,
  },
  title: {
    ...typography.headlineSm,
    color: colors.text,
  },
  languageContainer: {
    gap: spacing.md,
    marginTop: spacing.lg,
    marginBottom: spacing.xl,
  },
  languageItem: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 64,
    paddingHorizontal: spacing.margin,
    gap: spacing.md,
    borderRadius: radii.card,
    borderWidth: 1.5,
    borderColor: colors.border,
    backgroundColor: colors.surface,
  },
  languageItemSelected: {
    borderWidth: 2,
    borderColor: colors.secondary,
    backgroundColor: colors.mintTint,
  },
  languageItemPressed: {
    transform: [{scale: 0.98}],
  },
  languageText: {
    ...typography.bodyLg,
    fontFamily: fonts.medium,
    color: colors.text,
    flex: 1,
  },
  radio: {
    width: 22,
    height: 22,
    borderRadius: radii.pill,
    borderWidth: 2,
    borderColor: colors.border,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioSelected: {
    borderColor: colors.secondary,
  },
  radioDot: {
    width: 10,
    height: 10,
    borderRadius: radii.pill,
    backgroundColor: colors.secondary,
  },
});
